import React, { CSSProperties } from 'react';
import { useLocation } from 'react-router-dom';
import { Modal } from 'reactstrap';
import classNames from 'classnames';

import useIsMobile from '../../../../../hooks/useIsMobile';

import styles from './BaseTimeOptionsModal.module.scss';

const DEFAULT_WIDTH = 424;

type Props = {
  isOpen: boolean;
  width?: number | null;
  unmountOnClose?: boolean;
  children?: any;
  className?: string;
  customStyle?: CSSProperties | undefined;
  toggle?: () => void;
}

const BaseTimeOptionsModal = (props: Props) => {
  const { width = DEFAULT_WIDTH, customStyle, isOpen, unmountOnClose = true, children, className, toggle } = props;
  const scrollable = true;
  const isMobile = useIsMobile();
  const modalWidthBasicStyles = !width
    ? {}
    : ({
      maxWidth: width,
      margin: 'auto',
      position: 'absolute' as any,
      left: '8px',
      right: '8px',
    });

  return (
    <Modal
      centered
      isOpen={isOpen}
      modalClassName={className}
      backdropClassName={styles.backdrop}
      contentClassName={classNames(styles.modalContent, { [styles.mobile]: isMobile, [styles.web]: !isMobile })}
      zIndex={2100}
      style={customStyle || modalWidthBasicStyles}
      unmountOnClose={unmountOnClose}
      toggle={toggle}
      scrollable={scrollable}
    >
      {children}
    </Modal>
  );
};

export default BaseTimeOptionsModal;
